import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES, TERMS, DISCLAIMER, PRIVACY } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import About from "./about/About";
import Rooms from "./rooms/Rooms";
import Conferences from "./conferences/Conferences";
import Gallery from "./gallery/Gallery";
import Book from "./book/Book";
import Contact from "./contact/Contact";
import Legal from "./legal/Legal";
import NotFound from "./general/NotFound";

const PAGES = [
  { path: ROUTES.HOME, element: <Home /> },
  { path: ROUTES.ABOUT, element: <About /> },
  { path: ROUTES.ROOMS, element: <Rooms /> },
  { path: ROUTES.CONFERENCES, element: <Conferences /> },
  { path: ROUTES.GALLERY, element: <Gallery /> },
  { path: ROUTES.BOOK, element: <Book /> },
  { path: ROUTES.CONTACT, element: <Contact /> },
  { path: ROUTES.TERMS, element: <Legal page={TERMS} /> },
  { path: ROUTES.DISCLAIMER, element: <Legal page={DISCLAIMER} /> },
  { path: ROUTES.PRIVACY, element: <Legal page={PRIVACY} /> },
];

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
        onClick={(e) => {
          e.preventDefault();
          document.getElementById("main").focus();
        }}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
        tabIndex={-1}
      >
        <Routes>
          {PAGES.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={element}
            />
          ))}
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
